var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.notifications,
    on: {
      "click": _setup.handleClick
    }
  }, [_c('button', {
    class: _vm.$style.notifications__button
  }, [_c(_setup.SIcon, {
    class: _vm.$style.notifications__icon,
    attrs: {
      "icon": "i-notificationBell",
      "size": "24"
    }
  })], 1), _vm._v(" "), _vm.hasUnreadNotifications ? _c('div', {
    class: _vm.$style.notifications__dot
  }) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };